export const getStudioHomeData = state => state.studioHome.studioHomeData;
export const getLoadingStatuses = (state) => state.studioHome.loadingStatuses;
export const getSavingStatuses = (state) => state.studioHome.savingStatuses;
export const getStudioHomeCoursesParams = (state) => state.studioHome.studioHomeCoursesRequestParams;
export const getCompanyManagementPortalGeneralData = (state) => state.studioHome.companyManagement;
export const getSelectedCompanyDetails = (state) => state.studioHome.selectedCompanyDetails;
export const getCompanyCatalog = (state) => state.studioHome.companyCatalog;
export const getLegacyLicenses = (state) => state.studioHome.legacyLicenses;
export const getPlatforms = (state) => state.studioHome.platforms;
export const getPrograms = (state) => state.studioHome.programs;
export const getSelectedCompanyOrPlatformKey = (state) => state.studioHome.selectedCompanyOrPlatformKey;
export const getFullCourseList = (state) => state.studioHome.fullCourseList;
export const getCompanyCachedData = (state) => state.studioHome.companyCachedData;
export const getCompanyCachedDataByOrg = (state) => state.studioHome.companyCachedDataByOrg;
export const getSelectedCompanyCachedDataState = (state) => {
  const selectedCompany = state.studioHome.selectedCompanyOrPlatformKey;
  if (!selectedCompany) {
    return null;
  }

  return state.studioHome.companyCachedDataByOrg[selectedCompany] || null;
};

export const getSelectedCompanyCachedDataManifest = (state, endpoint) => {
  const selectedCompany = state.studioHome.selectedCompanyOrPlatformKey;
  if (!selectedCompany || !endpoint) {
    return null;
  }

  return state.studioHome.companyCachedDataByOrg[selectedCompany]?.manifests?.[endpoint] || null;
};

// Stable empty-object reference so getSelectedCompanyCachedDataPages never returns a new
// object identity when there's no data yet - consumers using this in a useSelector/useMemo
// dependency must be able to see "no pages" as unchanged across renders. Returning a fresh
// `{}` literal here previously caused an unstable reference on every call, which made
// useMemo/useEffect dependents (e.g. LearnerManagementTable's fetchedPageSet) recompute and
// re-trigger on every render, leading to a "Maximum update depth exceeded" loop.
const EMPTY_CACHED_DATA_PAGES = {};

export const getSelectedCompanyCachedDataPages = (state, endpoint) => {
  const selectedCompany = state.studioHome.selectedCompanyOrPlatformKey;
  if (!selectedCompany || !endpoint) {
    return EMPTY_CACHED_DATA_PAGES;
  }

  return state.studioHome.companyCachedDataByOrg[selectedCompany]?.pages?.[endpoint] || EMPTY_CACHED_DATA_PAGES;
};
export const getCompanyEmployees = (state) => state.studioHome.companyEmployees;
export const getCompanyEmployeeCount = (state) => state.studioHome.companyEmployeeCount || 0;
export const getCompanyEmployeePage = (state) => state.studioHome.companyEmployeePage || 1;
export const getCompanyAdmins = (state) => state.studioHome.companyAdmins;

export const getCompanyEmployeePagesForOrg = (state, companyName) => (
  state.studioHome.companyEmployeePagesByOrg[companyName] || null
);

export const getCompanyEmployeesForOrg = (state, companyName) => {
  const pages = getCompanyEmployeePagesForOrg(state, companyName)?.pages || {};
  return Object.keys(pages)
    .map(Number)
    .sort((a, b) => a - b)
    .flatMap((page) => pages[page]?.results || []);
};

// Stable empty-object reference for the same reason as EMPTY_CACHED_DATA_PAGES above.
const EMPTY_LEARNER_ENROLLMENTS = {};

export const getLearnerEnrollmentsForOrg = (state, companyName) => {
  if (!companyName) {
    return EMPTY_LEARNER_ENROLLMENTS;
  }

  return state.studioHome.learnerEnrollmentsByOrg[companyName] || EMPTY_LEARNER_ENROLLMENTS;
};
